const initialState = {
    // name: 'full name',
    // email: 'prefilled@provider-email.com',
    // mainPhone: '0521010100',
    // smsEnabled: false,
    // 'phone-1': 123123123,
    // areas: [
    //
    // ]
    subjects: []
};

export default function providerReducer(state = initialState, action) {
    switch (action.type) {
        case 'UPDATE_PROVIDER': {
            const input = action.data;
            return {
                ...state,
                ...input
            }
        }
        default: {
            return state
        }
    }
}